import { render } from "./SurveySetup.vue?vue&type=template&id=2645a11b&scoped=true"
import script from "./SurveySetup.vue?vue&type=script&lang=js"
export * from "./SurveySetup.vue?vue&type=script&lang=js"

import "./SurveySetup.vue?vue&type=style&index=0&id=2645a11b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2645a11b"]])

export default __exports__